import type { EmoteType } from "../types/emoteType";

export function isStringAnEmote(str: string) {
    return (
        str === "chungus" ||
        str === "vault" ||
        str === "boom" ||
        str === "amogus" ||
        str === "sad" ||
        str === "cry" ||
        str == "avgn" ||
        str == "happy" ||
        str === "hopon" ||
        str === "sleep" ||
        str === "plusone" ||
        str === "lol" ||
        str === "sunglasses" ||
        str === "angry"
    );
}

export function convertStringToEmote(str: string): EmoteType {
    if (!isStringAnEmote(str)) {
        throw "String is not an emote!";
    }

    return str as EmoteType;
}
